"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RoundButton = function RoundButton(props) {
  var onClick = function onClick(e) {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  var border = props.color ? "var(--".concat(props.color, ")") : 'transparent';
  var background = props.backgroundColor ? props.backgroundColor : "";
  var width = props.width ? props.width : 36;
  var height = props.height ? props.height : 36;
  var iconColor = props.iconColor ? props.iconColor : props.color;
  var customStyles = {
    borderColor: props.borderColor ? "var(--".concat(props.borderColor, ")") : border,
    background: background
  };

  if (border !== 'transparent') {
    customStyles.borderWidth = 2;
    customStyles.borderStyle = 'solid';
  }

  if (props.size) {
    width = props.size;
    height = props.size;
  } // Tag Name


  var tag = 'div';

  if (props.href) {
    tag = 'a';
  }

  var btnStyles = Object.assign({}, customStyles);

  var attr = _objectSpread(_objectSpread({}, props), {}, {
    className: props.className ? props.className + ' RoundButton' : 'RoundButton',
    onClick: null,
    icon: null,
    border: border,
    background: background,
    iconSize: null,
    iconColor: null,
    width: null,
    height: null,
    backgroundColor: null
  });

  var link = tag === 'a' && !props.href.startsWith('http');
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({}, attr, {
    link: link,
    onClick: onClick,
    style: btnStyles,
    width: width,
    height: height,
    tag: tag
  }), props.icon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: props.icon,
    size: props.iconSize ? props.iconSize : 16,
    color: iconColor ? iconColor : _atoms.Color.White2
  }));
};

exports.RoundButton = RoundButton;